import { CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { NotificationsTab } from "@/components/settings/notifications-tab";

interface NotificationStepProps {
  isCompleted: boolean;
}

export function NotificationStep({ isCompleted }: NotificationStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">Configure Notifications</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Set up how you want to be alerted when threats are detected.
          A default email notification was created during signup.
        </p>
      </div>
      {isCompleted && (
        <Card>
          <CardContent className="flex items-center gap-3 p-4">
            <CheckCircle2 className="h-5 w-5 text-green-500" />
            <span className="text-sm">Notification channels configured</span>
          </CardContent>
        </Card>
      )}
      <NotificationsTab />
    </div>
  );
}
